export type { ProductFeaturesReviewsProps } from './ProductFeaturesReviews';
export { ProductFeaturesReviews } from './ProductFeaturesReviews';
